import axios from "axios";

// Helper function to get cookie
function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=').map(c => c.trim());
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

// Create axios instance — ICC dashboard traffic, isolated port
const iccApi = axios.create({
  baseURL: 'https://uatbe.talentsage.com:3001/',
  timeout: 300000, // fail after 5 minutes instead of hanging forever
  headers: { 
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to include token and mask_pii headers
iccApi.interceptors.request.use(config => {
  // Get token from loginResults cookie
  const loginResults = getCookie('loginResults');
  if (loginResults) {
    try {
      const parsed = JSON.parse(loginResults);
      const token = parsed[0]?.token;
      if (token) {
        config.headers['token'] = token;
      }
    } catch (e) {
      console.error('Error parsing loginResults cookie:', e);
    }
  }

  // Get mask_pii from cookie
  const maskPii = getCookie('mask_pii');
  if (maskPii) {
    config.headers['X-Mask-PII'] = maskPii;
  }
  
  return config;
}, error => {
  return Promise.reject(error);
});

// Flag to prevent multiple logout triggers
let isLoggingOut = false;

// Add response interceptor to handle expired tokens
iccApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if token expired
    if (error.response?.status === 401 && error.response?.data?.code === 'TOKEN_EXPIRED') {
      if (!isLoggingOut) {
        isLoggingOut = true;
        console.log('TOKEN_EXPIRED detected - triggering logout event');
        window.dispatchEvent(new CustomEvent('session-expired'));
      }
      
      return Promise.reject(error);
    }

    if (error.response?.status === 403) {
      console.warn('403 Forbidden:', error.config?.url, error.response?.data);
    }

    if (error.code === 'ECONNABORTED') {
      console.warn('Request timed out:', error.config?.url);
    }
    
    return Promise.reject(error);
  }
);

export default iccApi;